"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var env_exports = {};
__export(env_exports, {
  ONE_PLATFORM_ENV: () => ONE_PLATFORM_ENV,
  ONE_PUBLIC_PREFIX: () => ONE_PUBLIC_PREFIX,
  pickOnePublicEnv: () => pickOnePublicEnv
});
module.exports = __toCommonJS(env_exports);
var import_publicEnv = require("@vxrn/utils/publicEnv");
var ONE_PUBLIC_PREFIX = "ONE_PUBLIC_";
var ONE_PLATFORM_ENV = "ONE_PLATFORM";
function pickOnePublicEnv(env) {
  var picked = {};
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = Object.entries(env)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [key, value] = _step.value;
      if ((key.startsWith(ONE_PUBLIC_PREFIX) || key.startsWith("EXPO_PUBLIC_")) && value !== void 0) {
        picked[key] = value;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return (0, import_publicEnv.withExpoPublicEnvAliases)(picked);
}
//# sourceMappingURL=env.js.map
